export enum ReduxErrorTypes {
  OUTPUT_EXPRESSION_NOT_FOUND = 'OUTPUT_EXPRESSION_NOT_FOUND',
  INVALID_ACTION_ID = 'INVALID_ACTION_ID',
  INVALID_THRESHOLD_ID = 'INVALID_THRESHOLD_ID',
  INVALID_DATAROUTE_ID = 'INVALID_DATAROUTE_ID',
  INVALID_ACTION_TYPE = 'INVALID_ACTION_TYPE',
}

export enum EditorContainerType {
  MODAL = 'modal',
  PAGE = 'page',
}

export const THRESHOLD_UPDATE_TYPE = {
  OPERATOR: 'operator',
  LEFT_ACTION: 'leftAction',
  LEFT_ATTRIBUTE: 'leftAttribute',
  RIGHT_ACTION: 'rightAction',
  RIGHT_ATTRIBUTE_ID: 'rightAttributeId',
  RIGHT_ATTRIBUTE_VALUE: 'rightValue',
  REASON_CODE_GROUP_ID: 'reasonCodeGroupId',
  REASON_CODE_GROUP: 'reasonCodeGroup',
  RIGHT_LEFT_TAG_RESULT: 'leftTagResult',
} as const;
